import { Popover, Typography } from '@mui/material';
import { useState } from 'react';

type IncPopoverType = {
  PopoverIcon: React.ElementType;
  popoverContent: React.ReactNode;
};

const IncPopover = ({ PopoverIcon, popoverContent }: IncPopoverType) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <PopoverIcon
        sx={{ fontSize: 16, cursor: 'pointer', opacity: 0.75 }}
        onMouseOver={handlePopoverOpen}
        onMouseOut={handlePopoverClose}
        data-testid="IncPopover.Icon"
      />
      <Popover
        data-testid="IncPopover.Popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>{popoverContent}</Typography>
      </Popover>
    </>
  );
};

export default IncPopover;
